import { createFileRoute } from '@tanstack/react-router'
import { EmailSection } from '@/routes/(private)/(shell)/settings/profile/-components/email-section'
import { PasswordSection } from '@/routes/(private)/(shell)/settings/profile/-components/password-section'
import { PhotoNameSection } from '@/routes/(private)/(shell)/settings/profile/-components/photo-name-section'
import { TwoFactorSection } from '@/routes/(private)/(shell)/settings/profile/-components/two-factor-section'
import { useAccountActionResult } from '@/routes/(private)/(shell)/settings/profile/-hooks/use-account-action-result'
import { accountActionResultSearchSchema } from '@/routes/(private)/(shell)/settings/profile/-lib/account-action-result'

export const Route = createFileRoute('/(private)/(shell)/settings/profile/')({
	component: ProfilePage,
	validateSearch: accountActionResultSearchSchema
})

/**
 * The person's own account: how others see them, and how they sign in.
 *
 * **THE PASSWORD AND THE SECOND FACTOR ARE NOT CHANGED HERE.** They belong to
 * the organization's identity provider, and every button that touches them
 * starts an action on its branded pages and navigates there. The browser comes
 * back to this page with the outcome in the query string, which
 * `useAccountActionResult` announces and removes.
 *
 * **THE TWO READS ARE SEPARATE ON PURPOSE.** The profile is ours and the
 * security summary is Keycloak's; a provider that is slow or down takes the
 * last two sections with it and leaves the name and the photo usable.
 */
function ProfilePage() {
	useAccountActionResult()

	return (
		<div className='flex flex-col divide-y border-b'>
			<PhotoNameSection />
			<EmailSection />
			<PasswordSection />
			<TwoFactorSection />
		</div>
	)
}
